module.exports = __webpack_public_path__ + "img/ctrl-cross-resonance-stub-mid-1.73a2bbb8.svg";